import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useUser } from '../context/UserContext';
import { contactInfoSave } from '../types/api'; // Import your API functions
import PrivacyPolicyModal from './PrivacyPolicyModal';  // Import your Privacy Policy Modal
import { userInformation } from "../i18n/languageMap"; 

const UserDetailsForm: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useUser();
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const locationState = location.state ?? {};
  const { name, mobile, whatsapp, email } = locationState;
  const [language] = useState(locationState.language || user?.language || 'English');

  const labels = userInformation[language] || userInformation['English'];

  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    emailId: '',
    contact: '',
    gender: 'male',
    financeDevelopment: 'Y',
    purchase: 'Y',
    joinWithUs: 'Y',
    about: '',
    isAgreed: false,
    city: '',
    district: '',
    state: '',
    pincode: '',
    dateOfBirth: '',
  });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, type } = e.target;
    const value = type === 'checkbox' ? (e.target as HTMLInputElement).checked : e.target.value;
    setFormData(prevData => ({ ...prevData, [name]: value }));
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!formData.isAgreed) {
      alert(labels.agreeAlert);
      return;
    }
    try {
      await contactInfoSave(
        name,
        mobile,
        language,
        email,
        formData.firstName,
        formData.lastName,
        formData.contact,
        formData.gender,
        formData.financeDevelopment,
        formData.purchase,
        formData.joinWithUs,
        formData.emailId,
        formData.city,
        formData.district,
        formData.state,
        formData.pincode,
        formData.about,
        formData.dateOfBirth
      );
      navigate('/Completed', { state: { name, mobile, whatsapp, language, email } });
    } catch (error) {
      alert('There was an error submitting your information. Please try again.');
      console.error('Error saving contact info:', error);
    }
  };

  const handleReset = () => {
    setFormData({
      firstName: '', lastName: '', emailId: '', contact: '', gender: 'male', financeDevelopment: 'Y', joinWithUs: 'Y', purchase: 'Y',
      about: '', isAgreed: false, city: '', district: '', state: '', pincode: '', dateOfBirth:''
    });
  };
  const handlePrivacyPolicyClick = () => setIsModalOpen(true);
  const handleCloseModal = () => setIsModalOpen(false);

  return (
    <div className="div-container" style={{ textAlign: 'left' }}>
      <h1>{labels.title}</h1>
      <form onSubmit={handleSubmit}>
        <input type="text" name="firstName" value={formData.firstName} onChange={handleChange} placeholder={labels.firstName} required />
        <input type="text" name="lastName" value={formData.lastName} onChange={handleChange} placeholder={labels.lastName} required />

        <div style={{ display: 'flex' }}>
          <label>{labels.gender}</label>
          {["male", "female", "other"].map((g) => (
            <label key={g}>
              <input type="radio" name="gender" value={g} checked={formData.gender === g} onChange={handleChange} /> {labels[g]}
            </label>
          ))}
        </div>

        <label htmlFor="dateOfBirth">{labels.dateOfBirth || "Date of Birth"}</label>
        <input  type="date" name="dateOfBirth"  id="dateOfBirth" value={formData.dateOfBirth}  onChange={handleChange} required  />

        <input type="email" name="emailId" value={formData.emailId} onChange={handleChange} placeholder={labels.email} required />
        <input type="tel" name="contact" value={formData.contact} onChange={handleChange} placeholder={labels.contact} required />
        <input type="text" name="city" value={formData.city} onChange={handleChange} placeholder={labels.city} required />
        <input type="text" name="district" value={formData.district} onChange={handleChange} placeholder={labels.district} required />
        <input type="text" name="state" value={formData.state} onChange={handleChange} placeholder={labels.state} required />
        <input type="text" name="pincode" value={formData.pincode} onChange={handleChange} placeholder={labels.pincode} required />
        <textarea name="about" value={formData.about} onChange={handleChange} placeholder={labels.about} required />

        <div style={{ display: 'flex', alignItems: 'center' }}>
          <label htmlFor="agreement">
            <input type="checkbox" id="agreement" name="isAgreed" checked={formData.isAgreed} onChange={handleChange} required />
            {labels.agreement}<a href="#" onClick={(e) => { e.preventDefault(); handlePrivacyPolicyClick(); }}>{labels.policy}</a>.
          </label>
        </div>

        <PrivacyPolicyModal isOpen={isModalOpen} onClose={handleCloseModal} language={language} />

        <div>
          <button type="submit">{labels.submit}</button>
          <button type="reset" onClick={handleReset}>{labels.reset}</button>
        </div>
      </form>
    </div>
  );
};

export default UserDetailsForm;
